import React from "react";
import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.config";
import { toast } from "react-toastify";
import Spinner from "../components/Spinner";

function Contact() {
  const [message, setMessage] = useState("");
  const [landlord, setLandlord] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams();
  useEffect(() => {
    const getLandlord = async () => {
      const docRef = doc(db, "users", params.landlordId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setLandlord(docSnap.data());
        setLoading(false);
      } else {
        toast.error("Could not get landlord data");
      }
    };
    getLandlord();
  }, [params.landlordId]);
  const onChange = (e) => setMessage(e.target.value);

  return (
    <div className="pageContainer">
      <header>
        <p className="pageHeader">Contatta il proprietario</p>
      </header>
      {loading ? (
        <Spinner />
      ) : (
        <main>
          <div className="contactLandlor">
            <p className="landlordName">Contatta {landlord?.name}</p>
          </div>
          <form className="messageForm">
            <div className="messageDiv">
              <label htmlFor="message" className="messageLabel">
                Messaggio
              </label>
              <textarea
                name="message"
                id="message"
                className="textarea"
                value={message}
                onChange={onChange}
              ></textarea>
            </div>
            <a
              href={`mailto:${landlord.email}?Subject=${
                searchParams.get("listingName") + " - Piattaforma immobiliare"
              }&body=${message}`}
            >
              <button className="primaryButton" type="button">
                Invia Messaggio
              </button>
            </a>
          </form>
          <br />
          <br />
          <br />
          <br />
        </main>
      )}
    </div>
  );
}

export default Contact;
